// extracted by mini-css-extract-plugin
module.exports = {"iconDropdown":"_1_ZFFOzgDkxpwHaZFOkaqE"};